import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.copyNumber.status',
  title: {
    id: 'omicsExplorer.filters.copyNumber.status',
    defaultMessage: 'Effect',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'status',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.copyNumber.status.amplification',
        searchValue: 'amplification',
        intlLabel: {
          id: 'omicsExplorer.filters.copyNumber.status.amplification',
          defaultMessage: 'Amplification',
        },
      },
      {
        id: 'omicsExplorer.filters.copyNumber.status.gain',
        searchValue: 'gain',
        intlLabel: {
          id: 'omicsExplorer.filters.copyNumber.status.gain',
          defaultMessage: 'Gain',
        },
      },
      {
        id: 'omicsExplorer.filters.copyNumber.status.neutral',
        searchValue: 'neutral',
        intlLabel: {
          id: 'omicsExplorer.filters.copyNumber.status.neutral',
          defaultMessage: 'Neutral',
        },
      },
      {
        id: 'omicsExplorer.filters.copyNumber.status.partialLoss',
        searchValue: 'partialLoss,partial-loss,partial_loss',
        intlLabel: {
          id: 'omicsExplorer.filters.copyNumber.status.partialLoss',
          defaultMessage: 'Partial Loss',
        },
      },
      {
        id: 'omicsExplorer.filters.copyNumber.status.loss',
        searchValue: 'loss',
        intlLabel: {
          id: 'omicsExplorer.filters.copyNumber.status.loss',
          defaultMessage: 'Loss',
        },
      },
    ],
  },
};
